/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcelsQueryResponse,
  GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcelsPathParams,
  GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcelsQueryParams,
  GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcels401,
  GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcels500,
} from "../../types/individualPaymentLookupsController/GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcels.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcels } from "../../clients/individualPaymentLookupsController/getApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcels.ts";

export const getApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcelsQueryKey =
  (
    courseFinancialId: GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcelsPathParams["courseFinancialId"],
    params?: GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcelsQueryParams,
  ) =>
    [
      {
        url: "/api/v1/individualpayment/course-financials/:courseFinancialId/available-number-parcels",
        params: { courseFinancialId: courseFinancialId },
      },
      ...(params ? [params] : []),
    ] as const;

export type GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcelsQueryKey =
  ReturnType<
    typeof getApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcelsQueryKey
  >;

export function getApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcelsQueryOptions(
  courseFinancialId: GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcelsPathParams["courseFinancialId"],
  params?: GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcelsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey =
    getApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcelsQueryKey(
      courseFinancialId,
      params,
    );
  return queryOptions<
    GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcelsQueryResponse,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcels401
      | GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcels500
    >,
    GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcelsQueryResponse,
    typeof queryKey
  >({
    enabled: !!courseFinancialId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcels(
        courseFinancialId,
        params,
        { ...config, signal: config.signal ?? signal },
      );
    },
  });
}

/**
 * @description Retorna 1..N do método (mínimo 1) mais a opção "Outros"; 'currentNumberParcels' maior que N prevalece. Migrado do legado IndividualPayment/GetAvailableNumberParcelsByCourse. **(Requer Authorization para autenticação)**
 * @summary Opções de número de parcelas do método de pagamento (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/course-financials/:courseFinancialId/available-number-parcels}
 */
export function useGetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcels<
  TData =
    GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcelsQueryResponse,
  TQueryData =
    GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcelsQueryResponse,
  TQueryKey extends QueryKey =
    GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcelsQueryKey,
>(
  courseFinancialId: GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcelsPathParams["courseFinancialId"],
  params?: GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcelsQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcelsQueryResponse,
        ResponseErrorConfig<
          | GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcels401
          | GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcels500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcelsQueryKey(
      courseFinancialId,
      params,
    );

  const query = useQuery(
    {
      ...getApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcelsQueryOptions(
        courseFinancialId,
        params,
        config,
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcels401
      | GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailableNumberParcels500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
